//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import MapLoader from '../amap/asyncLoadJs.js'

export default {
    name: 'amapLocation',
    data() {
        return {
            map: null,
            edit: false, // 是否可编辑
            placeSearch: null,
            poiList: [],
            selectIndex: -1, // 选中位置
            show: false,
            currLocation: null
        }
    },
    watch: {
        selectIndex(newValue, oldValue) {
            if (newValue != oldValue && newValue != -1 && this.poiList.length > newValue) {
                let poi = this.poiList[newValue];
                this.map.setCenter([poi.location.lng, poi.location.lat]);

                this.map.clearMap();
                var marker = new AMap.Marker({
                    position: new AMap.LngLat(poi.location.lng, poi.location.lat)
                });
                this.map.add(marker)
            }
        },
        show(newValue, oldValue) {
            if (newValue && newValue != oldValue) {
                if (this.selectIndex != -1 && this.poiList.length > this.selectIndex) {
                    let poi = this.poiList[this.selectIndex];
                    this.map.setCenter([poi.location.lng, poi.location.lat]);

                    if (this.map.getZoom() < 10) {
                        this.map.setZoom(16)
                    }
                }
            }

        }
    },
    props: {
        value: {
            type: Object,
            default: null
        }
    },
    methods: {
        /**
         * 加载地图
         */
        loadMap() {
            let that = this;
            MapLoader().then(AMap => {
                that.map = new AMap.Map('amapContainer', {
                    zoom: 17,
                    resizeEnable: true
                });
                that.getLocation();
                that.initAutocomplete();
                that.initPlaceSearch()

            }, e => {
                console.error('地图加载失败', e)
            })
        },
        /**
         * 获取去当前位置
         */
        getLocation() {
            let that = this;
            this.map.plugin('AMap.Geolocation', function () {
                var geolocation = new AMap.Geolocation({
                    enableHighAccuracy: true, //是否使用高精度定位，默认:true
                    timeout: 10000, //超过10秒后停止定位，默认：无穷大
                    maximumAge: 0, //定位结果缓存0毫秒，默认：0
                    convert: true, //自动偏移坐标，偏移后的坐标为高德坐标，默认：true
                    showButton: true, //显示定位按钮，默认：true
                    buttonPosition: 'RB', //定位按钮停靠位置，默认：'LB'，左下角
                    buttonOffset: new AMap.Pixel(10, 20), //定位按钮与设置的停靠位置的偏移量，默认：Pixel(10, 20)
                    showMarker: true, //定位成功后在定位到的位置显示点标记，默认：true
                    showCircle: true, //定位成功后用圆圈表示定位精度范围，默认：true
                    panToLocation: true, //定位成功后将定位到的位置作为地图中心点，默认：true
                    zoomToAccuracy: true //定位成功后调整地图视野范围使定位位置及精度范围视野内可见，默认：false
                });

                that.map.addControl(geolocation);
                geolocation.getCurrentPosition();
                AMap.event.addListener(geolocation, 'complete', onComplete);
                AMap.event.addListener(geolocation, 'error', onError);

                function onComplete(data) { // data是具体的定位信息
                    that.edit = true;
                    that.selectIndex = -1;
                    that.placeSearch.search(data.formattedAddress)
                }

                function onError(data) { // 定位出错
                    console.error(data);
                }
            })
        },
        /**
         * 初始化自动匹配输入
         */
        initAutocomplete() {
            let that = this;
            AMap.plugin('AMap.Autocomplete', function () {

                // 实例化Autocomplete
                var autoComplete = new AMap.Autocomplete({
                    city: '全国',
                    input: 'Autocomplete'
                });

                AMap.event.addListener(autoComplete, 'complete', onComplete);
                AMap.event.addListener(autoComplete, 'error', onError);
                AMap.event.addListener(autoComplete, 'select', onSelect);

                function onComplete(data) {
                }

                function onError(data) {
                }

                function onSelect(data) { // 选择输入
                    that.selectIndex = -1;
                    that.placeSearch.search(data.poi.name)
                }
            })
        },
        /**
         * 初始化搜索服务
         */
        initPlaceSearch() {
            let that = this;
            AMap.plugin('AMap.PlaceSearch', function () {

                that.placeSearch = new AMap.PlaceSearch({
                    pageSize: 30,
                    renderStyle: 'default',
                    extensions: 'all'
                });

                AMap.event.addListener(that.placeSearch, 'complete', onComplete);
                AMap.event.addListener(that.placeSearch, 'error', onError);

                function onComplete(data) {
                    that.selectIndex = 0;
                    that.poiList = data.poiList.pois;

                    if (!that.value || !that.value.address) { // 第一次获取到位置，回传回去，能减少打开页面频率
                        let poi = that.poiList[that.selectIndex];
                        let address = {
                            address: (poi.pname || '') + (poi.cityname || '') + (poi.adname || '') + (poi.address || '') + (
                                poi.name ||
                                ''),
                            lng: poi.location.lng,
                            lat: poi.location.lat
                        };
                        that.$emit('input', address);
                    }
                }

                function onError(err) {
                    console.error(err);
                }

            })
        },
        /**
         * 确定选择
         */
        enter() {
            let poi = this.poiList[this.selectIndex];
            let address = {
                address: (poi.pname || '') + (poi.cityname || '') + (poi.adname || '') + (poi.address || '') + (poi.name ||
                    ''),
                lng: poi.location.lng,
                lat: poi.location.lat
            };
            this.$emit('input', address);
            this.show = false
        }
    },
    created() {
        this.loadMap()
    }
}



// WEBPACK FOOTER //
// ./src/components/amap/amapLocation.vue